import axios from '../helpers/axios'
import qs from 'querystring';
import { logError } from '../services';
import {
  IResponse,
  IProjectManager,
  IProjectManagerCreate,
  IProjectManagerDetail,
  IProjectManagerUpdate,
  IProjectManagerActiveNeighborhood
} from '../models';

export const getProjectManagers = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  search?: string;
  territoryId?: string | number;
  neighborhoodId?: string | number;
}): Promise<IResponse<IProjectManager[]>> => {
  try {
    const { data } = await axios.get(`/api/project-managers`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagers failed');
    return Promise.reject(error.response.data);
  }
};

export const createProjectManager = async (payload: IProjectManagerCreate): Promise<number> => {
  try {
    const { data } = await axios.post(`/api/project-managers`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'createProjectManager failed');
    return Promise.reject(error.response.data);
  }
};

export const getProjectManagerDetail = async (
  projectManagerId: string | number
): Promise<IProjectManagerDetail> => {
  try {
    const { data } = await axios.get(`/api/project-managers/${projectManagerId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagerDetail failed');
    return Promise.reject(error.response.data);
  }
};

export const updateProjectManager = async (
  projectManagerId: string | number,
  payload: IProjectManagerUpdate
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/project-managers/${projectManagerId}`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updateProjectManager failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteProjectManager = async (projectManagerId: string | number) => {
  try {
    const { data } = await axios.delete(`/api/project-managers/${projectManagerId}`);
    return data;
  } catch (error: any) {
    logError(error, 'updateProjectManager failed');
    return Promise.reject(error.response.data);
  }
};

export const getProjectManagerAvailableNeighborhoods = async (
  projectManagerId: string | number
): Promise<IProjectManagerActiveNeighborhood[]> => {
  try {
    const { data } = await axios.get(
      `/api/project-managers/${projectManagerId}/available-neighborhoods`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagerAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};

export const createProjectManagerNeighborhood = async (
  projectManagerId: string | number,
  neighborhoodId?: string | number
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `/api/project-managers/${projectManagerId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'createProjectManagerNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteProjectManagerNeighborhood = async (
  projectManagerId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `/api/project-managers/${projectManagerId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getProjectManagerAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};
